// DesviacionesLineChart.jsx
import React from 'react';
import { LineChart } from '@carbon/charts-react';
import '@carbon/charts/styles.css';

const DesviacionesLineChart = ({
  data = [],
  title = 'Desviaciones de inicio y término',
  height = '400px',
}) => {

  const chartData = data.map(d => ({
    group: d.group,    // "Día - Inicio", "Día - Término", etc.
    date: new Date(d.date),
    value: d.value_h,
  }));

  const options = {
    title,
    height,
    theme: 'g100', // ⬅⬅⬅ modo oscuro (texto blanco)

    axes: {
      bottom: {
        mapsTo: 'date',
        title: 'Fecha',
        scaleType: 'time',
      },
      left: {
        mapsTo: 'value',
        title: 'Desviación (horas)',
        scaleType: 'linear',
      },
    },

    legend: {
      enabled: true,
    },

    curve: 'curveMonotoneX',

    color: {
      scale: {
        'Día - Inicio': '#0F62FE',      // azul claro
        'Día - Término': '#4589FF',     // azul brillante
        'Noche - Inicio': '#8A3FFC',    // morado
        'Noche - Término': '#BE95FF',   // morado claro
      },
    },
  };

  return <LineChart data={chartData} options={options} />;
};

export default DesviacionesLineChart;